import React from 'react';
import { Avatar, Button } from 'antd';
import { MenuFoldOutlined } from '@ant-design/icons';

const UserChip = ({ name, role, handleCollapse }) => {
	return (
		<div style={{
			margin: "10px",
			backgroundColor: "#062340",
			textAlign: "center",
			height: "50px",
			borderRadius: "8px",
			boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
			display: "flex",
			alignItems: "center",
			padding: "0 10px",
			overflow: "hidden"
		}}>
			<Avatar style={{
				backgroundColor: '#fde3cf',
				color: '#f56a00',
				marginRight: "10px"
			}}>
				{name[0]}
			</Avatar>
			<div style={{
				color: "#fff",
				textAlign: "left",
				flex: 1,
				overflow: "hidden"
			}}>
				<p style={{
					margin: 0,
					fontWeight: "bold",
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis"
				}}>
					{name}
				</p>
				<p style={{
					margin: 0,
					color: "#eee",
					fontSize: "12px",
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis"
				}}>
					{role}
				</p>
			</div>
			<Button 
				type='text' 
				style={{
					fontSize: '16px',
					width: 40,
					height: 40,
					color: "#fff"
				  }}
				icon={<MenuFoldOutlined/> }
				onClick={handleCollapse}
			/>
		</div>
	);
}

export default UserChip;
